import { render, staticRenderFns } from "./ProlongRules.vue?vue&type=template&id=dcf3181a&scoped=true"
import script from "./ProlongRules.vue?vue&type=script&lang=js"
export * from "./ProlongRules.vue?vue&type=script&lang=js"
import style0 from "./ProlongRules.vue?vue&type=style&index=0&id=dcf3181a&prod&lang=css"
import style1 from "./ProlongRules.vue?vue&type=style&index=1&id=dcf3181a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf3181a",
  null
  
)

export default component.exports